import { createFileRoute } from '@tanstack/react-router';

import Fleets from '@/modules/fleets/pages/Fleets';

export const Route = createFileRoute('/_authenticated/_system/_tenant/fleets/')(
  {
    head: () => ({
      meta: [{ title: 'Frotas' }],
    }),
    component: Fleets,
  },
);
